import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Dashboard from './Dashboard';
import {toast} from "react-toastify";
import {
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import moment from 'moment-timezone';
import {withTranslation} from "react-i18next";
import ILocalAGGrid, {
  getDefaultColDef,
} from "../../grid/iLocalAGGrid";
import {getDefaultDateRange} from "../../../utils/datetime.utils";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";


class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {order, orderBy, t} = this.props;
    const currentLang = localStorage.getItem('i18nextLng');

    const rows = [
      { id: "store", numeric: false, disablePadding: false, label: t("Report.Temperature.Store"), padding: '10px' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.Temperature.Location"), padding: '10px' },
      currentLang === 'en' && { id: "side", numeric: false, disablePadding: false, label: t("Report.Temperature.Side"), padding: '10px' },
      { id: "port", numeric: false, disablePadding: false, label: t("Report.Temperature.Port"), padding: '10px' },
      { id: "temperature", numeric: false, disablePadding: false, label: t("Report.Temperature.Temperature"), padding: '10px', textAlign: 'center' },
      { id: "connectwith", numeric: false, disablePadding: false, label: t("Report.Temperature.ConnectWith"), padding: '10px' },
      { id: "action", numeric: false, disablePadding: false, label: "", padding: '10px' },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
              >
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

const styles = theme => ({
  root: {
    width: "100%",
    position: 'relative'
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  },
  padding10px: {
    padding: '10px'
  }
  ,
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    borderRadius: '5px',
    fontSize: 'large',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
      borderRadius: '5px',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
      borderRadius: '5px',
    }
  }
});

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 5,
      loader: false,
      isDataEmpty: true,
      selectedObject: null,
      isUserValidate: false,
      storeData: [],
      startDate: '',
      endDate: '',
      isDownloadInProcess: false,
      isDownloadDialogOpen: false,
      downloadRow: null,
      fromdate: null,
      todate: null,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale
    };
  }

  componentDidMount() {
    // Default download range (last 7 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      loader: true,
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
    });
    this.getDashboardData();
  }

  fetchDashboardData = async (data) => {
    const history = await fetch(process.env.REACT_APP_BASEURL + 'temperature/history/by/expansion', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(res => {
        return res;
      })
    return history;
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }
  getDashboardData = () => {
    fetch(process.env.REACT_APP_BASEURL + 'temperature/monitoring/report', {
      method: 'get',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(async (res) => {
        const rows = Array.isArray(res) ? res : [];
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 3);
        let endDate = new Date();
        this.setState({ storeData: rows, startDate: startDate, endDate: endDate });
        const rowsWithHistory = await this.loadHistoryForRows(rows, startDate, endDate);
        this.setState({ storeData: rowsWithHistory, loader: false });
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  }

  // Attach each expansion's temperature history directly onto its grid row.
  // The AG Grid wrapper memoizes columnDefs, so the Temperature cell renderer
  // only re-runs when the row data itself changes; keeping the chart data in a
  // separate state array left the cells empty after the history requests returned.
  loadHistoryForRows = async (rows, startDate, endDate) => {
    const parentAccountId = sessionStorage.getItem('parentAccountId');
    return Promise.all(
      (rows || []).map(async (row) => {
        const history = await this.fetchDashboardData({
          startdate: startDate,
          enddate: endDate,
          expansionId: row.expansionId,
          parent_account_id: parentAccountId,
        });
        return { ...row, history: Array.isArray(history) ? history : [] };
      })
    );
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  // Download icon: open the From/To date dialog for the clicked row, starting
  // from the default (last 7 days) range each time.
  openDownloadDialog = (event, row) => {
    event && event.preventDefault();
    if (!row) return;
    const defaultDates = getDefaultDateRange();
    this.setState({
      isDownloadDialogOpen: true,
      downloadRow: row,
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
    });
  };

  closeDownloadDialog = () => {
    this.setState({ isDownloadDialogOpen: false, downloadRow: null });
  };

  downloadReport = () => {
    const { t } = this.props;
    const { fromdate, todate, downloadRow } = this.state;
    if (!downloadRow) return;
    if (!fromdate || !moment(fromdate).isValid()) {
      toast.error(t('Toast.Error.SelectFromDate'));
      return;
    }
    if (!todate || !moment(todate).isValid()) {
      toast.error(t('Toast.Error.SelectToDate'));
      return;
    }
    if (moment(fromdate).startOf('day').isAfter(moment(todate).endOf('day'))) {
      toast.error(t('Report.Temperature.FromDateAfterToDate'));
      return;
    }
    const requestObj = {
      fromdate: moment(fromdate).startOf('day').tz(timeZone),
      todate: moment(todate).endOf('day').tz(timeZone),
      expansionId: downloadRow.expansionId,
      parent_account_id: sessionStorage.getItem('parentAccountId')
    };
    this.setState({ loader: true, isDownloadDialogOpen: false });
    fetch(process.env.REACT_APP_BASEURL + "CSV/TemperatureHistoryReport", {
      method: "POST",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        this.setState({ loader: false, downloadRow: null });
        let csvRow = [];
        let A = [
          [
            "Store",
            "Location",
            "Side",
            "Temperature",
            "Connect With",
            "Date",
          ],
        ];
        let re = res && (res.Results || res.results) && (res.Results || res.results).length > 0 
          ? (res.Results || res.results) 
          : [];
        if (re && re.length > 0) {
          for (let item = 0; item < re.length; item++) {
            A.push([
              re[item].store !== undefined ? re[item].store : "",
              re[item].boxname !== undefined ? re[item].boxname : "",
              re[item] && re[item].direction === 1 ? "Left" : "Right",
              re[item].temperature !== undefined ? re[item].temperature : "",
              re[item].connectedwith !== undefined ? re[item].connectedwith : "",
              re[item].temperature_timestamp
                ? this.convertToTimeZone(re[item].temperature_timestamp)
                : "",
            ]);
          }
        }
        for (let i = 0; i < A.length; i++) {
          // Escape double quotes and commas in CSV fields
          csvRow.push(
            A[i]
              .map(field =>
                typeof field === "string" && (field.includes(",") || field.includes('"'))
                  ? `"${field.replace(/"/g, '""')}"`
                  : field
              )
              .join(",")
          );
        }
        let csvString = csvRow.join("\r\n");
        let blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        let a = document.createElement("a");
        if (navigator.msSaveBlob) { // For IE 10+
          navigator.msSaveBlob(blob, "TemperatureMonitoring.csv");
        } else {
          let url = URL.createObjectURL(blob);
          a.href = url;
          a.download = "TemperatureMonitoring.csv";
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      })
      .catch(() => {
        this.setState({ loader: false, downloadRow: null });
        toast.error(t('Toast.Error.Generic'));
      });
  }

  // From/To pickers inside the download dialog. These only drive the CSV
  // export range; the charts keep their own window.
  onFromDateSelect = date => {
    this.setState({ fromdate: date ? moment(date) : null });
  };

  onToDateSelect = date => {
    this.setState({ todate: date ? moment(date) : null });
  };

  renderDownloadDialog() {
    const { classes, t } = this.props;
    const { isDownloadDialogOpen, downloadRow, fromdate, todate, locale } = this.state;
    const dateFormat = localStorage.getItem('i18nextLng') === 'en' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
    const subtitle = downloadRow
      ? [downloadRow.store, downloadRow.box, downloadRow.comPort].filter(Boolean).join(' - ')
      : '';
    return (
      <Dialog open={isDownloadDialogOpen} onClose={this.closeDownloadDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          {t("Report.Temperature.DownloadReportButton")}
          {subtitle ? (
            <div style={{ fontSize: '0.85rem', fontWeight: 400, color: 'rgba(0,0,0,0.6)' }}>{subtitle}</div>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
            <Grid container spacing={2} style={{ paddingTop: '8px' }}>
              <Grid item xs={12} sm={6}>
                <DesktopDatePicker
                  disableFuture
                  inputFormat={dateFormat}
                  value={fromdate ? moment(fromdate).toDate() : null}
                  onChange={this.onFromDateSelect}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth variant="standard" label={t("Report.Temperature.FromDate")} />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DesktopDatePicker
                  disableFuture
                  inputFormat={dateFormat}
                  minDate={fromdate ? moment(fromdate).toDate() : undefined}
                  value={todate ? moment(todate).toDate() : null}
                  onChange={this.onToDateSelect}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth variant="standard" label={t("Report.Temperature.ToDate")} />
                  )}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeDownloadDialog}>{t("Global.Cancel")}</Button>
          <Button onClick={this.downloadReport} className={classes.primaryButton} disabled={!fromdate || !todate}>
            {t("Report.Temperature.Download")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const {classes, t} = this.props;
    const { storeData, rowsPerPage } = this.state;
    const currentLang = localStorage.getItem('i18nextLng');
    return (
      <div>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        {this.renderDownloadDialog()}
<div className={classes.tableWrapper}>
          <ILocalAGGrid
            columnDefs={[
              { field: "store", headerName: t("Report.Temperature.Store"), colId: "store" },
              { field: "box", headerName: t("Report.Temperature.Location"), colId: "box" },
              ...(currentLang === "en"
                ? [{ field: "side", headerName: t("Report.Temperature.Side"), colId: "side" }]
                : []),
              { field: "comPort", headerName: t("Report.Temperature.Port"), colId: "port" },
              {
                colId: "temperature",
                headerName: t("Report.Temperature.Temperature"),
                filter: false,
                sortable: false,
                // Take all leftover grid width; the chart reflows to the cell.
                flex: 1,
                minWidth: 520,
                suppressAutoSize: true,
                cellClass: "ilocal-temp-chart-cell",
                // Expose the history array as the cell value so AG Grid
                // re-renders the chart when a row's history is (re)loaded.
                valueGetter: (params) => (params.data && params.data.history) || null,
                cellRenderer: (params) => {
                  const n = params.data;
                  if (!n || !Array.isArray(n.history)) return null;
                  return (
                    <div
                      onMouseDown={(event) => event.stopPropagation()}
                      onPointerDown={(event) => event.stopPropagation()}
                      style={{ width: '100%' }}
                    >
                      <Dashboard
                        key={n.expansionId}
                        data={n.history}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        convertTimeZone={this.convertToTimeZone}
                        tempUnit={n.tempUnit}
                      />
                    </div>
                  );
                },
              },
              { field: "connectedWith", headerName: t("Report.Temperature.ConnectWith"), colId: "connectwith" },
              {
                field: "action",
                headerName: "",
                colId: "action",
                filter: false,
                sortable: false,
                resizable: false,
                width: 64,
                minWidth: 64,
                maxWidth: 64,
                suppressAutoSize: true,
                suppressMenu: true,
                cellClass: "ilocal-temp-action-cell",
                cellRenderer: (params) => (
                  <Tooltip key="single-edit" title={t("Report.Temperature.DownloadReportButton")}>
                    <IconButton
                      aria-label="downloadreport"
                      onClick={(event) => this.openDownloadDialog(event, params.data)}
                      style={{ fontSize: "2rem", padding: 4 }}
                      sx={() => ({ "&:hover": { backgroundColor: "#6cca98", color: "#fff" } })}
                    >
                      <DownloadForOfflineOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="clientSide"
            rowData={storeData || []}
            paginationPageSize={rowsPerPage || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={170}
            getRowId={(params) =>
              (params.data && (params.data.expansionId || params.data.id || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
          />

        </div>

      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/temparature_monitoring/index.js